import React, { useEffect } from 'react';
import { useAuth } from '../contexts/AuthContext';
import { useNavigate } from 'react-router-dom';
import { Button, Container, Title, Text, Stack } from '@mantine/core';

const LoginPage: React.FC = () => {
  const { isAuthenticated, login, isLoading } = useAuth();
  const navigate = useNavigate();

  useEffect(() => {
    if (isAuthenticated) {
      navigate('/');
    }
  }, [isAuthenticated, navigate]);

  if (isLoading) {
    return (
      <Container size="xs" style={{ marginTop: '100px', textAlign: 'center' }}>
        <Title order={2}>Loading...</Title>
      </Container>
    );
  }

  return (
    <Container size="xs" style={{ marginTop: '100px' }}>
      <Stack gap="lg" align="center">
        <img 
          src={`${process.env.PUBLIC_URL || ''}/logo-dark-sm.png`} 
          alt="TimberTrack Logo" 
          style={{ height: '60px', width: 'auto' }}
        />
        <Title order={1}>TimberTrack</Title>
        <Text size="lg" c="dimmed">
          IoT Device Control Platform
        </Text>
        <Button 
          size="lg" 
          onClick={login}
          style={{ marginTop: '20px' }}
        >
          Login with Keycloak
        </Button>
      </Stack>
    </Container>
  );
};

export default LoginPage;
